import { useAppState, useAppDispatch } from '../../Shared/AppContext';

export function useSessionTokensState() {
  return useAppState();
}

export function useSessionTokensActions() {
  const dispatch = useAppDispatch();

  function initializeState() {
    dispatch((appState) => ({
      ...appState,
      loading: true,
      pageNumber: null,
      numberOfPages: 1,
      sessionTokens: [],
      deleteSessionTokenModalIsOpen: false,
      sessionTokenToDelete: null,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function onResponse(response) {
    dispatch((appState) => ({ ...appState, ...response }));
  }

  function onError(feedback) {
    dispatch((appState) => ({ ...appState, ...feedback }));
  }

  function clearFeedback() {
    dispatch((appState) => ({
      ...appState,
      feedbackMessage: null,
      feedbackVariant: null,
    }));
  }

  function openDeleteSessionTokenModal(sessionToken) {
    dispatch((appState) => ({
      ...appState,
      deleteSessionTokenModalIsOpen: true,
      sessionTokenToDelete: sessionToken,
    }));
  }

  function closeDeleteSessionTokenModal() {
    dispatch((appState) => ({
      ...appState,
      deleteSessionTokenModalIsOpen: false,
      sessionTokenToDelete: null,
    }));
  }

  return {
    initializeState,
    onResponse,
    onError,
    clearFeedback,
    openDeleteSessionTokenModal,
    closeDeleteSessionTokenModal,
  };
}
